import { isNativePlatform } from '@/utils/capacitor';
import { isPublicCustomerPath } from '@/utils/publicCustomerPaths';

/** Tailwind `md` breakpoint — below this = mobile viewport. */
export const GUEST_MODE_MAX_WIDTH_PX = 767;

/**
 * Guest browse (Apple review home) is for native apps and mobile web only.
 * Desktop web browsers keep the classic login-first entry.
 */
export function isGuestModeEnabled(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  if (isNativePlatform()) {
    return true;
  }
  if (typeof window.matchMedia !== 'function') {
    return true;
  }
  return window.matchMedia(`(max-width: ${GUEST_MODE_MAX_WIDTH_PX}px)`).matches;
}

export function canBrowseAsGuest(pathname: string): boolean {
  return isGuestModeEnabled() && isPublicCustomerPath(pathname);
}
